import React from "react"
import { Route, Redirect } from 'react-router-dom';

import SimpleRoute from './simpeRoute';

import { authService, routingService } from '../../services/imports';
import { defaults } from '../../models/imports';

// Route available only when the user is authenticated; otherwise redirects to
// the landing page and remembers where the user wanted to go (state.from),
// so that "Sign in" can return there after the Keycloak round trip.
// Sessions created/ended in other tabs are handled by authService (reload).
export default class PrivateRoute extends SimpleRoute {
    constructor(props) {
        super(props);
    }

    render() {
        if (authService.isAuthenticated()) {
            return (<Route {...this.getInjectedProps()} />);
        }

        const from = window.location.pathname + window.location.search;
        return (
            <Redirect to={{ pathname: routingService.routePath(defaults.notAuthRoute), state: { from } }} />
        );
    }
}
